import { Routes } from '@angular/router';
import { authGuard } from './guards/auth-guard'; 

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/forgot-passowrd/forgot-passowrd.page').then( m => m.ForgotPassowrdPage)
  },

  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.page').then( m => m.HomePage),
    canActivate: [authGuard] 
  },
  {
    path: 'job-status',
    loadComponent: () => import('./pages/job-status/job-status.page').then( m => m.JobStatusPage),
    canActivate: [authGuard] 
  },
  {
    path: 'folder/:id',
    loadComponent: () =>
      import('./folder/folder.page').then((m) => m.FolderPage),
    canActivate: [authGuard] 
  },
  {
    path: 'job-detail/:id',
    loadComponent: () => import('./pages/job-detail/job-detail.page').then( m => m.JobDetailPage),
    canActivate: [authGuard] 
  },
  {
    path: 'trip-progress/:id',
    loadComponent: () => import('./pages/trip-progress/trip-progress.page').then( m => m.TripProgressPage),
    canActivate: [authGuard] 
  },
  {
    path: 'signature-capture/:id',
    loadComponent: () => import('./pages/signature-capture/signature-capture.page').then( m => m.SignatureCapturePage),
    canActivate: [authGuard] 
  },
  {
    path: 'create-job-order',
    loadComponent: () => import('./pages/create-job-order/create-job-order.page').then( m => m.CreateJobOrderPage),
    canActivate: [authGuard] 
  },
  {
    path: 'create-driver',
    loadComponent: () => import('./pages/create-driver/create-driver.page').then( m => m.CreateDriverPage),
    canActivate: [authGuard] 
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile.page').then( m => m.ProfilePage),
    canActivate: [authGuard] 
  },
  {
    path: 'podium',
    loadComponent: () => import('./pages/podium/podium.page').then( m => m.PodiumPage),
    canActivate: [authGuard] 

  },
  {
    path: 'jobs-list',
    loadComponent: () => import('./pages/jobs-list/jobs-list.page').then( m => m.JobsListPage),
    canActivate: [authGuard] 
  },

  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  },



];